// Path separator normalization for display.
//
// Stored folder paths come from mixed sources (customer Windows drop folders,
// Unix hosts, server-side Path.Combine on a non-matching host), so a single
// string can end up mixing "\" and "/". We never want to show both styles in
// one path — a path should render in the style of its own platform: Windows
// paths (drive letter, or containing backslashes) use "\", everything else "/".

function isWindowsStyle(path) {
  // Drive-letter root ("C:\...") or contains a backslash but is not a Unix
  // absolute path ("/foo").
  return /^[A-Za-z]:/.test(path) || (path.includes("\\") && !path.startsWith("/"));
}

// Normalize every separator in `path` to the single style implied by the path
// itself. Returns the input unchanged when it is empty or not a string.
export function formatPath(path) {
  if (!path || typeof path !== "string") return path;
  return isWindowsStyle(path) ? path.replace(/\//g, "\\") : path.replace(/\\/g, "/");
}

// Join a base path with one or more trailing segments using the base path's
// own separator style, then normalize. Avoids the "C:\dir/file" mix produced by
// a hard-coded "/" join.
export function joinPath(base, ...segments) {
  const parts = [base, ...segments].filter(Boolean).map(String);
  if (parts.length === 0) return "";
  const sep = isWindowsStyle(parts[0]) ? "\\" : "/";
  const joined = parts
    .map((p, i) => {
      let s = p;
      if (i > 0) s = s.replace(/^[\\/]+/, "");                 // trim leading sep on later parts
      if (i < parts.length - 1) s = s.replace(/[\\/]+$/, "");  // trim trailing sep on all but last
      return s;
    })
    .filter(Boolean)
    .join(sep);
  return formatPath(joined);
}
